import {actionTypes} from '@/core/constants'
import api from '@/core/apiclient'


export default {

    async [actionTypes.ATENDIMENTO.BUSCAR_ATENDIMENTOS_PACIENTE]({state}) {
        const {filtros, paginacao} = state.resultadoBuscaTodosAtendimentos
        const {data} = await api.atendimento.buscarAtendimentosPaginado(filtros, paginacao)
        return data
    },

    async [actionTypes.ATENDIMENTO.BUSCAR_ATENDIMENTO_POR_ID](context, input) {
        const {data} = await api.atendimento.buscarAtendimentoPorId(input)
        return data
    },

    async [actionTypes.ATENDIMENTO.AGENDAR_ATENDIMENTO](context, input) {
        await api.atendimento.agendarAtendimento(input)
    },

    async [actionTypes.ATENDIMENTO.INICIAR_ATENDIMENTO](context, input) {
        const {data} = await api.atendimento.iniciarAtendimento(input)
        return data
    },

    async [actionTypes.ATENDIMENTO.CANCELAR_ATENDIMENTO](context, input) {
        const {data} = await api.atendimento.cancelarAtendimento(input)
        return data
    },

    async [actionTypes.ATENDIMENTO.FINALIZAR_ATENDIMENTO](context, input) {
        const {data} = await api.atendimento.finalizarAtendimento(input)
        return data
    },

    async [actionTypes.ATENDIMENTO.REMOVER_ATENDIMENTO](context, input) {
        await api.atendimento.removerAtendimento(input)
    },

    async [actionTypes.ATENDIMENTO.ATUALIZAR_ATENDIMENTO_PACIENTE](context, input) {
        const {data} = await api.atendimento.atualizarAtendimento(input)
        return data
    },

    async [actionTypes.ATENDIMENTO.INSERIR_PROCEDIMENTO](context, input) {
        const {data} = await api.atendimento.inserirProcedimento(input)
        return data
    },

    async [actionTypes.ATENDIMENTO.ATUALIZAR_PROCEDIMENTO](context, input) {
        const {data} = await api.atendimento.atualizarProcedimento(input)
        return data
    },

    async [actionTypes.ATENDIMENTO.REMOVER_PROCEDIMENTO](context, input) {
        await api.atendimento.removerProcedimento(input)
    },

    async [actionTypes.ATENDIMENTO.BUSCAR_HISTORICO_PROCEDIMENTO]({state}) {
        const {filtros, paginacao} = state.resultadoBuscaTodosProcedimentos
        const {data} = await api.atendimento.buscarHistoricoProcedimento(filtros, paginacao)
        return data
    },
}